import React from 'react';
import { useOpenOrdersQuery } from '../../../modules/customer/queries';
import { GridContainer, GridItem } from '../../../visual-components/grid/grid';
import { InPageLoader } from '../../../visual-components/in-page-loader/in-page-loader';
import { OpenOrders as OpenOrdersComponent } from './open-orders';
import { SectionWrapper } from './section-wrapper';

export const OpenOrders: React.FC = () => {
  const {
    data: openOrderData,
    isLoading: isLoadingOpenOrders,
    isError: hasErrorOpenOrders,
    error: openOrdersError,
  } = useOpenOrdersQuery();

  const { items: openOrders } = openOrderData ?? { items: [] };

  return (
    <>
      {isLoadingOpenOrders && openOrders.length === 0 ? (
        <SectionWrapper>
          <GridContainer>
            <GridItem>
              <InPageLoader />
            </GridItem>
          </GridContainer>
        </SectionWrapper>
      ) : null}
      {openOrders.length > 0 || hasErrorOpenOrders ? (
        <SectionWrapper>
          <OpenOrdersComponent
            debugInfo="Error fetching open orders"
            error={openOrdersError}
            hasError={hasErrorOpenOrders}
            isLoading={isLoadingOpenOrders}
            openOrders={openOrders}
          />
        </SectionWrapper>
      ) : null}
    </>
  );
};
